import * as React from 'react';
import * as classNames from 'classnames';
import {filesize} from 'filesize';
import ReviewModel from '../../types/ReviewModel';
import ReviewVersionModel from '../../types/ReviewVersionModel';
import ReviewByDateContainer from '../ReviewByDate/ReviewByDateContainer';
import TimeFormatter from '../../utils/TimeFormatter/TimeFormatter';
import Strings from '../../globals/Strings';
import ContentTypeParser from '../../utils/ContentTypeParser/ContentTypeParser';
import {ControlButton, TscButtonType, Glyphs} from '@techsmith/tsc-cloud-style-guide';
import Themeable from '../../types/Themeable';
import {ModalStates} from '../../globals/Constants';
import ReviewersDetailElement from '../ReviewersDetailElement/ReviewersDetailElement';

export default ({review, reviewVersion, setModalState, themeName, isOwner}: DetailsPaneProps) => {
   const descriptionText = reviewVersion.Description ? reviewVersion.Description : Strings.labels.noDescriptionProvided;
   const descriptionClasses = classNames('left-element description', {empty: !reviewVersion.Description});
   const isVideo = ContentTypeParser.getContentTypeIsVideo(reviewVersion.MediaContentType);
   const titleString = review.Title + ' - ' + Strings.labels.versions.versionFull.replace('{param0}', reviewVersion.VersionNumber.toString());
   const titleElement =
      <div className="flex-container">
         <div className="left-element title" title={titleString}>{titleString}</div>
         {isOwner && review.ReviewVersions.filter(ver => !ver.IsDeleted).pop().VersionNumber === reviewVersion.VersionNumber &&
            <ControlButton
               title={Strings.labels.editTitle}
               buttonType={TscButtonType.tertiary}
               themeName={themeName}
               glyph={<Glyphs.Edit16x16/>}
               onClick={() => setModalState(ModalStates.editReviewTitle)}
               testId="details-pane-edit-review-title-button"
            />
         }
      </div>;

   const descriptionElement =
        <div className="flex-container">
            <div className={descriptionClasses}>{descriptionText}</div>
            {isOwner && review.ReviewVersions.filter(ver => !ver.IsDeleted).pop().VersionNumber === reviewVersion.VersionNumber &&
                <ControlButton
                  title={Strings.labels.editDescription}
                  buttonType={TscButtonType.tertiary}
                  themeName={themeName}
                  glyph={reviewVersion.Description ? <Glyphs.Edit16x16/> : <Glyphs.Add16x16/>}
                  onClick={() => setModalState(ModalStates.editReviewDescription)}
                  testId="details-pane-edit-review-description-button"
               />
            }
        </div>;

   return (
    <div className="details-pane">
        <div className="title-section">
            {titleElement}
            {descriptionElement}
        </div>
        <div className="section">
            <div className="section-label">{Strings.labels.addReviewersButtonText}</div>
            <ReviewersDetailElement review={review} reviewVersion={reviewVersion} isOwner={isOwner} themeName={themeName} setModalState={setModalState}/>
        </div>
        {review.ReviewVersions.filter(ver => !ver.IsDeleted).pop().VersionNumber === reviewVersion.VersionNumber &&
            <div className="section">
                <div className="section-label">{Strings.labels.startReviewModal.reviewDetails.deadline.title}</div>
                <div className="section-value deadline-value"><ReviewByDateContainer/></div>
            </div>
        }
        <div className="media-section">
            <div className="section-label">{Strings.labels.mediaInfo.fileName}</div>
            <div className="section-value" title={reviewVersion.FileName}>{reviewVersion.FileName}</div>
        </div>
        <div className="media-section">
            <div className="section-label">{Strings.labels.mediaInfo.type}</div>
            <div className="section-value">{reviewVersion.MediaContentType}</div>
        </div>
        <div className="media-section">
            <div className="section-label">{Strings.labels.mediaInfo.size}</div>
            <div className="section-value">{filesize(reviewVersion.FileSize)}</div>
        </div>
        <div className="media-section">
            <div className="section-label">{Strings.labels.mediaInfo.dimensions}</div>
            <div className="section-value">{reviewVersion.MediaWidth} x {reviewVersion.MediaHeight}</div>
        </div>
        {isVideo && <div className="media-section">
            <div className="section-label">{Strings.labels.mediaInfo.duration}</div>
            <div className="section-value">{TimeFormatter.formatTime(reviewVersion.MediaDuration)}</div>
        </div>}
    </div>
   );
};

export interface DetailsPaneProps extends Themeable {
   review: ReviewModel;
   reviewVersion: ReviewVersionModel;
   isOwner: boolean;
   setModalState(modalState: ModalStates): void;
}
